import { useState } from 'react';

interface TopBarProps {
  title: string;
  lastUpdate?: Date | null;
}

export function TopBar({ title, lastUpdate }: TopBarProps) {
  const currentTime = new Date();
  const [connectionStatus] = useState<'connected' | 'disconnected' | 'checking'>('connected');

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const formatDate = (date: Date) => {
    return date.toLocaleDateString('es-ES', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="bg-white/80 backdrop-blur-md border-b border-gray-100 px-8 py-4 sticky top-0 z-30 transition-all duration-300">
      <div className="flex items-center justify-between">
        {/* Título y breadcrumb */}
        <div>
          <h1 className="text-2xl font-bold text-gray-900 tracking-tight">{title}</h1>
          <div className="flex items-center space-x-2 mt-1 text-sm text-gray-500 font-medium">
            <i className="ri-home-4-line"></i>
            <span>Dashboard</span>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-blue-600">{title}</span>
          </div>
        </div>

        {/* Conexión y tiempo */}
        <div className="flex items-center space-x-6">

          {/* Estado de conexión */}
          <div className="flex items-center space-x-2 bg-green-50 px-3 py-1.5 rounded-full border border-green-100">
            <div className={`w-2 h-2 rounded-full ${connectionStatus === 'connected' ? 'bg-green-500 animate-pulse' :
              connectionStatus === 'checking' ? 'bg-yellow-500 animate-pulse' :
                'bg-red-500'
              }`}></div>
            <span className="text-xs font-semibold text-green-700 uppercase tracking-wider">
              {connectionStatus === 'connected' ? 'Sistema Online' :
                connectionStatus === 'checking' ? 'Verificando...' :
                  'Desconectado'}
            </span>
          </div>

          {/* Última actualización */}
          {lastUpdate && (
            <div className="flex items-center space-x-2 text-sm text-gray-500 bg-gray-50 px-3 py-1.5 rounded-full border border-gray-100">
              <i className="ri-refresh-line text-blue-500"></i>
              <span className="font-medium">Actualizado: {formatTime(lastUpdate)}</span>
            </div>
          )}

          {/* Fecha y hora actual */}
          <div className="flex items-center space-x-3 pl-6 border-l border-gray-200">
            <div className="text-right">
              <div className="text-sm font-bold text-gray-900 font-mono">
                {formatTime(currentTime)}
              </div>
              <div className="text-xs text-gray-500 capitalize font-medium">
                {formatDate(currentTime)}
              </div>
            </div>
            <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center text-blue-600">
              <i className="ri-time-line text-xl"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
